import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ReactPaginate from "react-paginate";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [allCategories, setAllCategories] = useState({});
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");

  const [itemOffsetJobs, setItemOffsetJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const filteredJobs = useMemo(() => {
    return jobs?.filter((job) => {
      const matchesCity =
        !selectedCityId || job?.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job?.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  // paginação vagas
  const endOffsetJobs = itemOffsetJobs + itemsPerPage;
  const currentJobs = filteredJobs?.slice(itemOffsetJobs, endOffsetJobs);
  const pageCountJobs = Math.ceil(filteredJobs?.length / itemsPerPage);

  const handlePageClickJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs?.length;
    setItemOffsetJobs(newOffset);

    document.getElementById("oportunidades").scrollIntoView();
  };

  const toggleBurguerMenu = () => {
    const burguerMenu = document.querySelector(".burguer-menu");
    const burguerContent = document.querySelector(".burguer-content");

    burguerMenu.onclick = function () {
      burguerContent.classList.toggle("show-menu");
    };

    burguerContent.onclick = function () {
      burguerContent.classList.remove("show-menu");
    };

    document.onclick = function (e) {
      if (
        !burguerMenu.contains(e.target) &&
        !burguerContent.contains(e.target)
      ) {
        burguerContent.classList.remove("show-menu");
      }
    };
  };

  const onChangeFilterJobsCity = ($event) => {
    setItemOffsetJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  const changeTab = ($event) => {
    const selectedTab = $event?.target?.value || $event;
    document.getElementById("oportunidades").scrollIntoView();
    setShowLoader(true);
    setItemOffsetJobs(0);
    setCurrentPage(0);

    const category = allCategories?.groupedJobPositionList[selectedTab] || [];

    setJobs(category);

    setTimeout(() => {
      setShowLoader(false);
    }, 2000);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  useEffect(() => {
    toggleBurguerMenu();
  });

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "femsa",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setAllCategories(jobsData);
          setJobs(jobsData?.groupedJobPositionList?.efetivas);
          setJobPositionCity(jobsData?.cityList);
          setJobPositionTitle(jobsData?.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);

          localStorage.clear();

          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  const jobTypes = () => {
    return (
      <>
        {showLoader && (
          <div className="w-full flex flex-col items-center mt-20 max-[768px]:w-full">
            <Spinner animation="grow" variant="primary" />
            <h4 className="text-[#3b82f6] mt-4">Carregando</h4>
          </div>
        )}
        {!showLoader && currentJobs?.length ? (
          <>
            <ul className="jobs-box">
              {currentJobs?.map((job, i) => (
                <li className="jobs-list" key={i}>
                  <div className="w-[70%] pl-3 max-[768px]:w-full max-[768px]:p-0">
                    <p className="!m-0 max-[768px]:text-center">{job.name}</p>
                  </div>
                  <div className="w-[30%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                    <Button
                      className="py-3 px-5 cursor-pointer self-end"
                      variant="primary"
                      href={job.shortUrl}
                      target="_blank"
                    >
                      candidatar-se
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
            <ReactPaginate
              containerClassName="pagination"
              breakLabel="..."
              nextLabel="Próximo >"
              onPageChange={handlePageClickJobs}
              pageRangeDisplayed={3}
              pageCount={pageCountJobs}
              forcePage={currentPage}
              previousLabel="< Anterior"
              renderOnZeroPageCount={null}
            />
          </>
        ) : null}
        {!showLoader && !currentJobs?.length ? (
          <div className="jobs-list justify-center">
            <h2 className="text-blue-500 text-xl">
              Não encontramos resultados para sua busca.
            </h2>
          </div>
        ) : null}
      </>
    );
  };

  return (
    <div>
      <nav className="bg-[#0F1941] h-25">
        <div className="flex items-center justify-between p-4 pr-[10%] relative">
          <div>
            <img
              src="./assets/icons/randstad-logo.png"
              alt="Coca Cola FEMSA Logo"
              className="h-26"
            />
          </div>

          <div className="burguer-menu cursor-pointer mb-1">
            <img
              src="./assets/icons/Menu.svg"
              alt="menu"
              className="rounded-none"
            />
          </div>

          <ul
            id="content-burger-menu"
            className="burguer-content flex flex-row mt-2 justify-end items-center gap-16 list-meu w-1/2"
          >
            <li>
              <a href="#sobre" className="text-white hover:!text-[#2074d9]">
                sobre nós
              </a>
            </li>
            <li>
              <a
                href="#oportunidades"
                className="text-white hover:!text-[#2074d9]"
              >
                oportunidades
              </a>
            </li>
            <li>
              <a
                href="https://www.randstad.com.br/contate-nos/contato-candidato/"
                target="_blank"
                className="text-white hover:!text-[#2074d9]"
                rel="noreferrer"
              >
                contato
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full bg-[#2074D9] flex justify-center items-center">
        <div
          id="main-title"
          className="flex flex-col items-start z-10 w-1/2 max-[768px]:hidden"
        >
          <p className="text-white text-7xl font-regular ml-[8%] max-[768px]:text-xl">
            venha fazer parte
          </p>
          <p className="text-white text-7xl font-regular ml-[22%] mt-2 max-[768px]:text-xl">
            da nossa equipe!
          </p>
          <img
            src="./assets/images/logo-femsa-banner.png"
            alt="Coca Cola FEMSA"
            className="w-[35%] mt-[10%] ml-[10%] max-[1024px]:mb-12"
          />
        </div>
        <div className="w-1/2 max-[768px]:w-full">
          <img
            src="./assets/images/landing-image-1.png"
            alt="Coca Cola FEMSA"
            className="w-full"
          />
        </div>
      </div>

      <div className="w-full flex flex-col justify-center mt-12 px-[7vw] py-6 max-[768px]:mt-14">
        <h1 className="text-3xl font-light text-blue-500">
          a parceria Coca-Cola FEMSA e Randstad
        </h1>
        <p className="text-lg text-black mt-2">
          A Coca-cola FEMSA, em parceria com a Randstad, líder global em
          soluções completas de recursos humanos, presente em 39 países pelo
          mundo, uniu forças para garantir um processo seletivo que além de
          selecionar talentos, também apresente como é trabalhar na
          engarrafadora pública com o maior volume de vendas no Sistema
          Coca-Cola, garantindo assim, a combinação perfeita entre oportunidade
          e talento, buscando inovação e melhorias contínuas para fazer o
          cuidado ser percebido por todos os públicos e pela sociedade.
        </p>
      </div>

      <div className="w-full flex items-center justify-center mb-4 max-[768px]:w-full">
        <img
          src="./assets/images/coca-cola-logo.png"
          alt="Logo Coca Cola FEMSA"
          className="w-[15%] max-[768px]:w-[30%]"
        />
        <img
          src="./assets/icons/logo-randstad-blue.png"
          alt="Logo Randstad"
          className="w-[15%] ml-12 max-[768px]:w-[20%]"
        />
      </div>

      <div
        className="flex w-full gap-6 py-14 px-[7vw] max-[768px]:flex-col !pt-0 justify-center items-center"
        id="sobre"
      >
        <div className="flex flex-col w-1/2 max-[768px]:w-full">
          <h1 className="text-3xl font-light text-blue-500 mb-4">
            sobre a Coca-Cola FEMSA Brasil
          </h1>
          <p className="text-lg text-black">
            A Coca-Cola FEMSA Brasil é responsável pela produção e distribuição
            das suas bebidas favoritas como Coca-Cola, Fanta, Sprite, Sucos Del
            Valle, Sol, entre outros. Sua operação está presente em 10 países da
            América Latina e no Brasil, além de marcar presença em 52% do
            território brasileiro nos principais estados como São Paulo, Minas
            Gerais, Mato Grosso do Sul, Rio de Janeiro, Paraná, Santa Catarina e
            Rio Grande do Sul.
          </p>
          <p className="text-lg text-black">
            Respeito e ética são bem mais do que conceitos para a Coca-Cola
            FEMSA Brasil, são valores e atitudes que adotam no relacionamento
            diário com seus colaboradores, consumidores, clientes, parceiros e
            todos aqueles que fazem parte do dia a dia.
          </p>
          <p className="text-lg text-black">
            Por esse motivo, sempre que consumir seus produtos, tenha a certeza
            de que eles são fabricados por meio do trabalho em conjunto de mais
            de 20 mil pessoas apaixonadas pelo que fazem e que assumem o
            compromisso verdadeiro de entregar com excelência a melhor bebida à
            mesa da sua família.
          </p>
          <p className="text-lg text-black">
            <li>93 milhões de consumidores</li>
          </p>
          <p className="text-lg text-black">
            <li>470 mil pontos de venda</li>
          </p>
          <p className="text-lg text-black">
            <li>21.000 colaboradores</li>
          </p>
          <p className="text-lg text-black">
            <li>47 centros de distribuição</li>
          </p>
          <p className="text-lg text-black">
            <li>11 fábricas</li>
          </p>
          <a href="#oportunidades" className="w-[350px]">
            <button className="bg-[#2074D9] text-white w-full h-[60px] rounded-sm hover:bg-blue-600 max-[768px]:w-full">
              Clique aqui e confira nossas vagas
            </button>
          </a>
        </div>

        <div className="w-1/2 h-auto max-[768px]:w-full">
          <img
            src="./assets/images/landing-image-3.png"
            alt="Coca Cola FEMSA"
            className="w-full"
          />
        </div>
      </div>

      <div
        id="proposito"
        className="w-full bg-[#2074D9] flex flex-row mb-16 gap-6 justify-center items-center"
      >
        <div className="w-[40%] px-8 max-[768px]:w-full max-[768px]:mb-4">
          <img
            src="./assets/images/landing-image-2.png"
            alt="Coca Cola FEMSA"
            className="w-full h-[80%]"
          />
        </div>

        <div className="w-[60%] px-8 flex flex-col max-[768px]:w-full">
          <h1 className="text-3xl font-light text-white mb-4 max-[768px]:mt-12">
            visão Coca-Cola FEMSA Brasil
          </h1>
          <div className="space-y-2 mb-6">
            <p className="text-lg text-white">
              Ser líder total de bebidas, gerando valor econômico, social e
              ambiental sustentável, gerenciando modelos de negócio inovadores
              com os melhores colaboradores do mundo.
            </p>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col justify-center px-[7vw] mb-2 max-[768px]:mt-14">
        <h1 className="text-3xl font-light text-blue-500 mb-4">
          toda história tem um bom começo!
        </h1>
        <p className="text-lg text-black">
          Foi assim que a Randstad surgiu: de uma grande ideia, através de uma
          bicicleta.
        </p>
        <p className="text-lg text-black">
          Foi de bike que nosso fundador, lá na Holanda em 1960, levou a
          primeira candidata à sua entrevista de emprego. Hoje, a Randstad é
          líder global em recrutamento e soluções completas de recursos humanos.
        </p>
        <p className="text-lg text-black">
          Nosso propósito é apoiar o maior número possível de pessoas a alcançar
          seu verdadeiro potencial ao longo de suas vidas profissionais. E temos
          a ambição de ser a empresa de talentos mais equitativa e especializada
          do mundo.
        </p>
      </div>

      <div
        className="w-full flex flex-col justify-center py-14 px-[7vw]"
        id="oportunidades"
      >
        <h1 className="text-3xl font-light text-blue-500 mb-4">
          quer uma oportunidade? então faça sua inscrição!
        </h1>

        <div className="w-full flex gap-4 items-center justify-end pt-[7%] max-[1024px]:flex-col">
          <select
            id="select-1"
            onChange={onChangeFilterJobsCity}
            className="filter-btn w-[250px] p-2 !m-0 cursor-pointer h-12 max-lg:w-full"
          >
            <option value="">Todas as cidades</option>
            {jobPositionCity.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
              </option>
            ))}
          </select>
          <select
            id="select-2"
            onChange={onChangeFilterJobsTitle}
            className="filter-btn w-[250px] p-2 !m-0 cursor-pointer h-12 max-lg:w-full"
          >
            <option value="">Todas os cargos</option>
            {jobPositionTitle.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name}
              </option>
            ))}
          </select>
        </div>

        <Tabs
          defaultActiveKey="efetivas"
          className="flex flex-row mb-2 mt-5 flex-nowrap"
          onSelect={changeTab}
        >
          <Tab eventKey="efetivas" title="Vagas para efetivos">
            {jobTypes()}
          </Tab>
          <Tab eventKey="temporarias" title="Vagas para temporários">
            {jobTypes()}
          </Tab>
        </Tabs>
      </div>

      <div className="bg-[#f7f5f0] px-[7vw] py-12">
        <p className="text-black text-2xl mb-8">
          Buscando dicas para a sua carreira? Confira nosso blog
        </p>
        <a
          href="https://www.randstad.com.br/guia-carreira/"
          target="_blank"
          className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition"
          rel="noreferrer"
        >
          acesse nosso blog
        </a>
      </div>

      <footer className="bg-[#2074D9] text-white py-8">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="mb-2">
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p>
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
            <p>
              A Randstad trata dados pessoais de acordo com a LGPD (Lei
              13.709/18). Leia nosso{" "}
              <a
                href="https://www.randstad.com.br/sobre-sua-privacidade/"
                target="_blank"
                className="text-white underline hover:no-underline"
                rel="noreferrer"
              >
                Aviso de Privacidade
              </a>
              .
            </p>
          </div>

          <div className="flex space-x-4 mb-12">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
